import type { RouteRecordRaw } from 'vue-router';
import { useBrandComponent } from '@/composables/useBrandComponent';

/**
 * Ruta del módulo Centro Administrativo (Soporte) v2 — carril A, Backlog 6.
 *
 * ⚠️ RUTA DE PREVISUALIZACIÓN (andamiaje, task 6.2). Igual que Pólizas v2 (3.1):
 *     se define aquí pero **se registra append-only** en `PrivateRoutes.ts` para
 *     poder ir viendo el avance por URL directa en `/private/support-v2`. **NO
 *     cambia el menú ni la ruta v1 `/private/support`** (name `Soporte`): el switch
 *     va al cierre del proyecto — un módulo, un switch. Revertir = quitar el spread;
 *     no se borra nada de v1.
 *
 *     Se usa `/private/support-v2` (no `/private/support`) para NO chocar con la ruta
 *     v1, que sigue viva y es a donde apunta el menú de perfil hoy.
 *
 * ── REGLA 2 — cómo se carga la vista ────────────────────────────────────────────
 * Se resuelve con `useBrandComponent`, NUNCA con `import()` directo, para que una
 * marca pueda sustituirla con su propio
 * `brand/src/modules/support-v2/views/SupportView.vue`.
 *
 * ── REGLA 3 — filtra EXACTAMENTE igual que la v1 que sustituye ───────────────────
 * Mismos `requiresPermission` / `minLevel` / `requiresSystemPermission` que la ruta
 * v1 `/private/support` (name `Soporte`): `brokerin` · 20 · `support`
 * (`src/router/PrivateRoutes.ts`). Si no, un usuario sin el permiso entraría a una
 * pantalla a la que hoy no tiene acceso.
 *
 * NOTA DE ALCANCE (análisis §0): «Folio administrativo» NO es una pantalla de este
 * módulo — es un ANCLA que abre el modal de nuevo folio de Pólizas (`#folio-nuevo`).
 * La única pantalla del Backlog 6 es Soporte (esta), con 2 pestañas. La entrada de
 * menú «Folio administrativo» se resuelve en la task 6.8 como enlace, no como ruta.
 */
export const supportV2Routes: RouteRecordRaw[] = [
    {
        // path relativo, se cuelga de `/private` desde PrivateRoutes.ts → /private/support-v2
        path: 'support-v2',
        name: 'Soporte v2',
        component: useBrandComponent('modules/support-v2/views/SupportView.vue'),
        meta: {
            requiresAuth: true,
            title: 'Soporte',
            requiresPermission: 'brokerin',
            minLevel: 20,
            requiresSystemPermission: 'support'
        }
    }
];
